export enum PaymentMethodGroup {
	LocalPayment = 1,
	EMoney = 2,
	Crypto = 3,
	TcWallet = 4
}